import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

export function useLoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const login = useAuthStore(state => state.login);
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state as any)?.from?.pathname || '/';

  const handleSubmit = async (e: React.FormEvent, recaptchaToken?: string | null) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login({ 
        email, 
        password, 
        rememberMe,
        recaptchaToken
      });
      
      navigate(from, { replace: true });
    } catch (err) {
      if (err instanceof Error) {
        // Provide more user-friendly error messages
        if (err.message.includes('Invalid login credentials')) {
          setError('メールアドレスまたはパスワードが正しくありません');
        } else if (err.message.includes('Email not confirmed')) {
          setError('メールアドレスが確認されていません。メールをご確認ください');
        } else {
          setError(err.message);
        }
      } else {
        setError('ログインに失敗しました');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return {
    email,
    password,
    rememberMe,
    error,
    isLoading,
    handleEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value),
    handlePasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value),
    handleRememberMeChange: (checked: boolean) => setRememberMe(checked),
    handleSubmit
  };
}